module.exports = __webpack_public_path__ + "img/img_bi_icon_05.31f1f3e4.png";